import { render, staticRenderFns } from "./ManageTagsDialog.vue?vue&type=template&id=136388e7&scoped=true"
import script from "./ManageTagsDialog.vue?vue&type=script&lang=ts"
export * from "./ManageTagsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManageTagsDialog.vue?vue&type=style&index=0&id=136388e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136388e7",
  null
  
)

export default component.exports